import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import bg from '../../assets/images/bank_overlay_bg.png';

const StyledBodyContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 30px;
	width: 380px;
	height: 350px;
	background: #111111;
	opacity: 0.98;
	border-radius: 50px 50px 0px 0px;
	margin-top: 77px;
	padding: 0 30px;
	transition: transform 0.3s ease;
	transform: translateY(200%);
`;

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 17, 17, 0.98);
	background-image: url(${bg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;

	transition: opacity 0.3s;
	opacity: 0;

	&.overlay-enter {
		opacity: 0;

		${StyledBodyContainer} {
			transform: translateY(200%);
		}
	}

	&.overlay-enter-active,
	&.overlay-enter-done,
	&.overlay-exit {
		opacity: 1;

		${StyledBodyContainer} {
			transform: translateY(0);
		}
	}

	&.overlay-exit-active {
		opacity: 0;

		${StyledBodyContainer} {
			transform: translateY(200%);
		}
	}
`;

const StyledTopContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const StyledMoneyContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-top: 20px;

	${Text} {
		font-weight: 500;
		font-size: 30px;
		color: #ffffff;
	}

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledIconContainerBig = styled.div`
	position: absolute;
	top: -50px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100px;
	height: 100px;
	background: #111211;
	border-radius: 100px;
`;

const StyledIconContainerSmall = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 80px;
	height: 80px;
	background: #1f8034;
	border-radius: 80px;

	img {
		width: 40px;
		height: 40px;
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledBodyContainer,
	StyledContainer,
	StyledIconContainerBig,
	StyledIconContainerSmall,
	StyledMoneyContainer,
	StyledTopContainer,
};
